import { pReactWrapperDirective } from './pReactWrapper.directive';

export default angular.module('frontend.react', ["frontend.theme"])
  .directive('pReactWrapper', pReactWrapperDirective);
